import { Filter } from "components/DesignSystem/Filter/Filter";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useAppSelector } from "hooks/useAppSelector";
import { useFilters } from "hooks/useFilter";
import { useWindowSize } from "hooks/useWindowSize";
import { parse } from "qs";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getFilterStatus } from "store/selector/transactionFilter";
import { setTxnFilters } from "store/slices/transactionFilter";
import {
  Amount,
  CapsuleFilters,
  CategoryFilter,
  DateRangeFilter,
  OtherFilters,
  VendorsFilter,
} from "./Filter/Filter";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { FilterContext } from "components/DesignSystem/Filter/FilterContext";
import { Funnel } from "components/icons/Funnel";
import { Button } from "components/DesignSystem/Button/Button";

export const StripeTxnFilter = () => {
  const dispatch = useAppDispatch();
  const { isMobile } = useWindowSize();
  const { search } = useLocation();
  let query = parse(search, { ignoreQueryPrefix: true });
  const { appliedFilterCount } = useAppSelector(getFilterStatus);

  useEffect(() => {
    delete query.company;
    delete query.entity;
    delete query.page;
    delete query.selected_transaction_id;
    delete query.reset_filter;
    delete query.page;
    dispatch(setTxnFilters(query));
  }, [search]);

  const { values: dates, updateFilter: updateDateFilter } = useFilters({
    initialValue: {
      START_DATE: "",
      END_DATE: "",
      SELECT_PERIOD: "" as string,
    },
  });

  const [value, setValue] = useState("category");
  const [open, setOpen] = useState(false);

  const onSelect = (value: string) => {
    if (value) {
      setValue(value);
    }
  };

  const onOpenChange = (open: boolean) => {
    setOpen(open);
  };

  return (
    <FilterContext.Provider value={{ value, onSelect, setOpen, open: open }}>
      <Dropdown.Root open={open} onOpenChange={onOpenChange} modal={false}>
        <Dropdown.Trigger asChild>
          <Button
            size="xsmall"
            customType={appliedFilterCount > 0 ? "secondary" : "icon"}
          >
            <div className="t-flex t-items-center t-text-text-30 t-gap-1">
              <Funnel />
              {appliedFilterCount > 0 && `(${appliedFilterCount})`}
            </div>
          </Button>
        </Dropdown.Trigger>
        {!isMobile && <CapsuleFilters />}
        <Dropdown.Portal>
          <Filter.Portal>
            <Filter.List>
              <Filter.ListItem value="transactionDate">Date</Filter.ListItem>
              <Filter.ListItem value="vendors">Vendors</Filter.ListItem>
              <Filter.ListItem value="category">Category</Filter.ListItem>
              <Filter.ListItem value="amount">Amount</Filter.ListItem>
              <Filter.ListItem value="others">Others</Filter.ListItem>
            </Filter.List>
            <Filter.Body value="transactionDate" block>
              <DateRangeFilter values={dates} updateFilter={updateDateFilter} />
            </Filter.Body>

            <Filter.Body value="vendors" block>
              <VendorsFilter />
            </Filter.Body>
            <Filter.Body value="category" block>
              <CategoryFilter />
            </Filter.Body>
            <Filter.Body value="amount" block>
              <Amount />
            </Filter.Body>
            <Filter.Body value="others">
              <OtherFilters />
            </Filter.Body>
          </Filter.Portal>
        </Dropdown.Portal>
      </Dropdown.Root>
    </FilterContext.Provider>
  );
};
